export const BlocksIcon = ({ className }: { className?: string }) => {
    return (
        <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_137_13)">
                <path d="M6.5 10.5L12 13.5M6.5 10.5V4.5M6.5 10.5L1 13.5M12 13.5L17.5 10.5M12 13.5V7.5M12 13.5V19.5M12 13.5L6.5 16.5M12 13.5L17.5 16.5M17.5 10.5V4.5M17.5 10.5L23 13.5M17.5 4.5L12 1.5L6.5 4.5M17.5 4.5L12 7.5M6.5 4.5L12 7.5M6.5 22.5L1 19.5V13.5M6.5 22.5L12 19.5M6.5 22.5V16.5M12 19.5L17.5 22.5M1 13.5L6.5 16.5M17.5 22.5L23 19.5V13.5M17.5 22.5V16.5M23 13.5L17.5 16.5" stroke="white" strokeWidth="2" />
            </g>
            <defs>
                <clipPath id="clip0_137_13">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
